function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDogecoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.105 3.117v3.117H.438l.003.758.012.758.828.012.824.004v6.238l2.84-.012c3.09-.012 2.953-.004 3.723-.172 2.785-.617 4.426-2.652 4.68-5.789.039-.531.015-1.855-.043-2.289-.223-1.629-.762-2.851-1.668-3.793A5.4 5.4 0 0 0 10.078.797C9.195.359 8.301.125 7.152.027 6.961.012 5.812 0 4.465 0h-2.36Zm4.73-.52c1.81.141 3.145 1.126 3.661 2.708.36 1.097.367 2.558.02 3.62-.41 1.25-1.348 2.071-2.7 2.364-.441.094-.753.113-1.937.113H4.73V7.766h2.926V6.234L6.203 6.23 4.746 6.22l-.012-1.79c0-.984 0-1.808.012-1.827.016-.04 1.54-.047 2.09-.004m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "currentColor",
    fillOpacity: 1
  }
}));
export default SvgDogecoin;